import React from "react";
import { Image, Link, Stack } from "@fluentui/react";
import { AppTheme } from "./App";

interface FooterProps {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
}

const Footer: React.FC<FooterProps> = (props) => {
  return (
    <Stack horizontalAlign="center" tokens={{ childrenGap: "1rem" }} className="footer-container">
      <Stack>
        <Stack.Item>
          <Link href="https://www.rehngruppen.se" target="_blank" className="rehn-link">
            <Image src="./Rehngruppen_logotyp_neg_rgb_NEG.svg" width={500} height={76} />
          </Link>
        </Stack.Item>
      </Stack>
      <div className="spacer" />
    </Stack>
  );
};

export default Footer;
